import React from 'react';
import { IInteriorMaterial2, IProduct, IProductSubGroup } from '../../../services/WebApiClient';
import { State } from '../../../util/useState2';
import { LoadSpinner } from '../../LoadSpinner';
import { GenericEditor } from '../GenericEditor';
import { SingleProductEditor } from './SingleProductEditor';


export function SingleProductSubGroupAdmin(props: {
    productSubGroup: IProductSubGroup;
    onChange: () => void;
    interiorMaterials: IInteriorMaterial2[];
    selectedProductId: State<number | undefined>;
}) {

    function editorFunc(product: IProduct, onChange: () => void, updateCount: number) {
        if (!props.interiorMaterials) {
            return <LoadSpinner />;
        }
        return (
            <SingleProductEditor key={`${updateCount} ${product.id}`}
                onChange={() => props.onChange()}
                product={product}
                interiorMaterials={props.interiorMaterials}
            />
        );
    }

    return (
        <GenericEditor<IProduct>
            editorFunc={editorFunc}
            getterFunc={() => Promise.resolve(props.productSubGroup.products)}
            nameFunc={p => (
                <>
                    <b>{p.externalId}</b>
                    <br />
                    <span>{p.defaultName}</span>
                </>
            )}
            className="product-admin-editor no-right-menu"
            selectedId={props.selectedProductId}
            />
    );
}
